/**
 * 客户端唯一标识符管理
 * uid 是 viewport 同步的依据，用于区分不同客户端。
 * 由 app 层在认证初始化后通过 setClientUidProvider 注入真实来源（authStore.loginData.user_info.uuid）。
 */

let uidProvider: (() => string) | null = null;

/**
 * 由 app 层在认证初始化后调用，将 uid 来源指向 authStore。
 * 注入后 getClientUid 将优先使用此 provider 的返回值。
 */
export function setClientUidProvider(getter: () => string): void {
  uidProvider = getter;
}

/**
 * 获取客户端 uid。
 * 优先使用通过 setClientUidProvider 注入的来源（通常为 authStore.loginData.user_info.uuid）。
 * 在认证初始化前短暂回退到 localStorage 生成的临时 id。
 */
export function getUserID(): string {
  return uidProvider?.() || '';
}
